module.exports = __webpack_public_path__ + "img/icon_service.4712ebf9.png";